<template>
  <div class="brand-detail-page">
    <!-- 导航栏 -->
    <van-nav-bar
      :title="brandData?.name || $t('brands.detail')"
      left-arrow
      fixed
      placeholder
      @click-left="$router.back()"
    >
<!--      <template #right>-->
<!--        <van-icon-->
<!--          name="share-o"-->
<!--          @click="handleShare"-->
<!--        />-->
<!--      </template>-->
    </van-nav-bar>

    <!-- 加载状态 -->
    <div
      v-if="loading"
      class="loading-container"
    >
      <van-loading
        size="24px"
        vertical
      >
        {{ $t('brands.loading') }}
      </van-loading>
    </div>

    <!-- 错误状态 -->
    <div
      v-else-if="error"
      class="error-container"
    >
      <van-empty
        :description="$t('brands.loadFailed')"
        image="error"
      >
        <van-button
          round
          type="primary"
          @click="fetchBrandDetail"
        >
          {{ $t('brands.retry') }}
        </van-button>
      </van-empty>
    </div>

    <!-- 内容区域 -->
    <div
      v-else-if="brandData"
      class="content-container"
    >
      <!-- 品牌头部信息 -->
      <div class="brand-header">
        <div class="brand-basic-info">
          <div class="logo-section">
            <img
              :src="brandData.logo"
              :alt="brandData.name"
              class="brand-logo"
              @load="handleLogoLoad"
              @error="handleLogoError"
            >
            <div
              v-if="brandData.status === 1"
              class="logo-badge"
            >
              <van-icon name="certificate" />
              <span>{{ $t('brands.verified') }}</span>
            </div>
          </div>

          <div class="brand-info">
            <h1 class="brand-name">
              {{ brandData.name }}
            </h1>
            <p class="brand-desc">
              {{ brandData.desc }}
            </p>

            <div class="brand-stats">
              <div class="stat-item">
                <div class="stat-number">
                  {{ formatNumber(brandData.productCount) }}
                </div>
                <div class="stat-label">
                  {{ $t('brands.products') }}
                </div>
              </div>
<!--              <div class="stat-item">-->
<!--                <div class="stat-number">-->
<!--                  {{ formatNumber(brandData.verificationCount) }}-->
<!--                </div>-->
<!--                <div class="stat-label">-->
<!--                  {{ $t('brands.verifications') }}-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>

        <!-- 品牌时间信息 -->
        <div class="brand-time-info">
          <div class="time-item">
            <van-icon
              name="clock-o"
              class="time-icon"
            />
            <div class="time-content">
              <div class="time-label">
                {{ $t('brands.establishTime') }}
              </div>
              <div class="time-value">
                {{ formatDate(brandData.establishTime) }}
              </div>
            </div>
          </div>
          <!--          <div class="time-item">-->
          <!--            <van-icon-->
          <!--              name="calendar-o"-->
          <!--              class="time-icon"-->
          <!--            />-->
          <!--            <div class="time-content">-->
          <!--              <div class="time-label">-->
          <!--                {{ $t('brands.joinTime') }}-->
          <!--              </div>-->
          <!--              <div class="time-value">-->
          <!--                {{ formatDate(brandData.joinTime) }}-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>

      <!-- 品牌故事 -->
      <div
        v-if="brandData.brandStory"
        class="brand-story-section"
      >
        <div class="section-header">
          <van-icon
            name="book"
            class="section-icon"
          />
          <h2 class="section-title">
            {{ $t('brands.story') }}
          </h2>
        </div>
        <div class="brand-story-content">
          <p>{{ brandData.brandStory }}</p>
        </div>
      </div>

      <!-- 设计师团队 -->
      <div
        v-if="brandData.designers && brandData.designers.length"
        class="designers-section"
      >
        <div class="section-header">
          <van-icon
            name="friends"
            class="section-icon"
          />
          <h2 class="section-title">
            {{ $t('brands.designers') }}
          </h2>
        </div>
        <van-swipe
          class="designers-swipe"
          :loop="false"
          :width="120"
          :show-indicators="false"
        >
          <van-swipe-item
            v-for="designer in brandData.designers"
            :key="designer.id"
            class="designer-item"
          >
            <div class="designer-card">
              <img
                :src="designer.avatar"
                :alt="designer.name"
                class="designer-avatar"
              >
              <div class="designer-info">
                <h4 class="designer-name">
                  {{ designer.name }}
                </h4>
                <p class="designer-role">
                  {{ designer.role }}
                </p>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>

      <!-- 品牌产品 -->
      <div
        v-if="false"
        class="products-section"
      >
        <div class="section-header">
          <van-icon
            name="bag"
            class="section-icon"
          />
          <h2 class="section-title">
            {{ $t('brands.products') }}
          </h2>
          <span class="product-count">{{ brandData.productCount }} {{ $t('brands.items') }}</span>
        </div>

        <div class="products-grid">
          <div
            v-for="product in productsList"
            :key="product.id"
            class="product-card"
            @click="goToProductDetail(product.id)"
          >
            <div class="product-image">
              <img
                :src="product.image"
                :alt="product.name"
              >
              <div
                v-if="product.isNew"
                class="product-badge"
              >
                <van-tag
                  type="danger"
                  size="small"
                >
                  {{ $t('brands.new') }}
                </van-tag>
              </div>
            </div>
            <div class="product-info">
              <h4 class="product-name">
                {{ product.name }}
              </h4>
              <p class="product-desc">
                {{ product.description }}
              </p>
              <div class="product-price">
                ¥{{ product.price }}
              </div>
            </div>
          </div>
        </div>

        <!-- 加载更多 -->
        <div
          v-if="hasMoreProducts"
          class="load-more"
        >
          <van-button
            round
            type="primary"
            :loading="loadingMore"
            class="load-more-btn"
            @click="loadMoreProducts"
          >
            {{ $t('brand.loadMore') }}
          </van-button>
        </div>
      </div>

      <!-- 品牌认证信息 -->
      <div class="verification-section">
        <div class="section-header">
          <van-icon
            name="shield"
            class="section-icon"
          />
          <h2 class="section-title">
            {{ $t('brands.verification') }}
          </h2>
        </div>
        <div class="verification-content">
          <div class="verification-stats">
            <div class="verification-item">
              <van-icon
                name="certificate"
                class="verification-icon"
              />
              <div class="verification-info">
                <div class="verification-number">
                  {{ brandData.verificationCount }}
                </div>
                <div class="verification-label">
                  {{ $t('brands.totalVerifications') }}
                </div>
              </div>
            </div>
<!--            <div class="verification-item">-->
<!--              <van-icon-->
<!--                name="like"-->
<!--                class="verification-icon"-->
<!--              />-->
<!--              <div class="verification-info">-->
<!--                <div class="verification-number">-->
<!--                  98%-->
<!--                </div>-->
<!--                <div class="verification-label">-->
<!--                  {{ $t('brands.authenticityRate') }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>

          <!--          <van-button-->
          <!--            type="primary"-->
          <!--            size="large"-->
          <!--            icon="certificate"-->
          <!--            class="verify-btn"-->
          <!--            @click="goToVerification"-->
          <!--          >-->
          <!--            {{ $t('brands.verifyProduct') }}-->
          <!--          </van-button>-->
        </div>
      </div>

      <!-- 底部操作栏 -->
      <div class="bottom-actions">
        <!--        <van-button-->
        <!--          round-->
        <!--          type="primary"-->
        <!--          icon="certificate"-->
        <!--          class="action-btn primary-btn"-->
        <!--          @click="goToVerification"-->
        <!--        >-->
        <!--          {{ $t('brands.verifyNow') }}-->
        <!--        </van-button>-->
        <!--        <van-button-->
        <!--          round-->
        <!--          icon="share-o"-->
        <!--          class="action-btn secondary-btn"-->
        <!--          @click="handleShare"-->
        <!--        >-->
        <!--          {{ $t('brands.share') }}-->
        <!--        </van-button>-->
        <!--        <van-button-->
        <!--          round-->
        <!--          icon="star-o"-->
        <!--          :class="['action-btn', 'secondary-btn', { 'followed': isFollowing }]"-->
        <!--          @click="handleFollow"-->
        <!--        >-->
        <!--          {{ isFollowing ? $t('brands.following') : $t('brands.follow') }}-->
        <!--        </van-button>-->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { showToast } from 'vant'
import { queryBrandDetail } from '@/api/brand'
import { getUserLang } from '@/storage/user'
export default {
  name: 'BrandDetail',
  setup () {
    const { t } = useI18n()
    const router = useRouter()
    const route = useRoute()

    // 响应式数据
    const loading = ref(true)
    const error = ref(false)
    const loadingMore = ref(false)
    const brandData = ref<any>(null)
    const logoLoaded = ref(false)
    const currentPage = ref(1)

    // 模拟产品数据
    const productsList = ref([
      {
        id: 1,
        name: '经典款手提包',
        description: '优质皮革制作，经典设计',
        image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
        price: '1280.00',
        isNew: true
      },
      {
        id: 2,
        name: '时尚斜挎包',
        description: '轻便实用，日常搭配',
        image: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
        price: '899.00',
        isNew: false
      },
      {
        id: 3,
        name: '商务公文包',
        description: '专业场合，彰显品味',
        image: 'https://images.unsplash.com/photo-1553545204-5336bc12ca32?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
        price: '1580.00',
        isNew: true
      },
      {
        id: 4,
        name: '旅行双肩包',
        description: '大容量设计，旅行必备',
        image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
        price: '680.00',
        isNew: false
      }
    ])

    const hasMoreProducts = computed(() => {
      return productsList.value.length < (brandData.value?.productCount || 0)
    })

    // 方法
    const getBrandDetail = async () => {
      loading.value = true
      error.value = false

      queryBrandDetail(brandId.value).then(res => {
        brandData.value = res
      }).catch(error => {
        error.value = true
        showToast(t('brand.loadFailed'))
      }).finally(() => {
        loading.value = false
      })

      // try {
      //   // 模拟API调用
      //   await new Promise(resolve => setTimeout(resolve, 1500))
      //
      //   // 模拟根据ID获取数据
      //   brandData.value = mockBrandData
      // } catch (err) {
      //   error.value = true
      //   showToast(t('brand.loadFailed'))
      // } finally {
      //   loading.value = false
      // }
    }

    const formatDate = (dateString: string) => {
      const date = new Date(dateString)
      const lang = getUserLang()
      return new Intl.DateTimeFormat(lang, {
        year: 'numeric',
        month: '2-digit'
        // day: '2-digit'
      }).format(date)
    }

    const formatNumber = (num: number) => {
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + '万'
      }
      return num.toString()
    }

    const handleLogoLoad = () => {
      logoLoaded.value = true
    }

    const handleLogoError = () => {
      console.error('品牌logo加载失败')
    }

    const goToProductDetail = (productId: number) => {
      router.push(`/product/${productId}`)
    }

    const loadMoreProducts = async () => {
      loadingMore.value = true

      try {
        // 模拟加载更多产品
        await new Promise(resolve => setTimeout(resolve, 1000))

        // 模拟添加新产品
        const newProducts = [
          {
            id: productsList.value.length + 1,
            name: '新款钱包',
            description: '多卡位设计，实用便捷',
            image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
            price: '480.00',
            isNew: true
          },
          {
            id: productsList.value.length + 2,
            name: '时尚腰带',
            description: '真皮制作，精致扣头',
            image: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
            price: '320.00',
            isNew: false
          }
        ]

        productsList.value.push(...newProducts)
        currentPage.value++
      } catch (err) {
        showToast(t('brands.loadMoreFailed'))
      } finally {
        loadingMore.value = false
      }
    }

    const brandId = ref(0)
    // 生命周期
    onMounted(() => {
      brandId.value = parseInt(route.query.brandId as string || '0')
      if (brandId.value) {
        getBrandDetail()
      }
    })
    return {
      brandData,
      productsList,
      loading,
      error,
      hasMoreProducts,
      formatDate,
      formatNumber,
      handleLogoLoad,
      handleLogoError,
      goToProductDetail,
      loadMoreProducts
    }
  }
}

</script>

<style lang="scss" scoped>
.brand-detail-page {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.loading-container,
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

/* 品牌头部信息 */
.brand-header {
  background: white;
  margin: 0 16px 16px;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.brand-basic-info {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.logo-section {
  position: relative;
  flex-shrink: 0;

  .brand-logo {
    width: 100px;
    height: 100px;
    border-radius: 16px;
    object-fit: cover;
    border: 1px solid #f0f0f0;
  }

  .logo-badge {
    position: absolute;
    left: 20px;
    //bottom: -5px;
    //right: -5px;
    background: linear-gradient(135deg, #07c160 0%, #05a54f 100%);
    color: white;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 10px;
    display: flex;
    align-items: center;
    gap: 2px;

    .van-icon {
      font-size: 10px;
    }
  }
}

.brand-info {
  flex: 1;
  min-width: 0;

  .brand-name {
    margin: 0 0 8px;
    font-size: 24px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.2;
  }

  .brand-desc {
    margin: 0 0 16px;
    font-size: 14px;
    line-height: 1.5;
    color: #666;
  }
}

.brand-stats {
  display: flex;
  gap: 20px;

  .stat-item {
    text-align: center;

    .stat-number {
      font-size: 20px;
      font-weight: 700;
      color: #1989fa;
      margin-bottom: 4px;
    }

    .stat-label {
      font-size: 12px;
      color: #999;
    }
  }
}

.brand-time-info {
  display: flex;
  gap: 20px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;

  .time-item {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;

    .time-icon {
      font-size: 18px;
      color: #1989fa;
      flex-shrink: 0;
    }

    .time-content {
      .time-label {
        font-size: 12px;
        color: #999;
        margin-bottom: 2px;
      }

      .time-value {
        font-size: 14px;
        font-weight: 500;
        color: #333;
      }
    }
  }
}

/* 通用区块样式 */
.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  .section-icon {
    font-size: 18px;
    color: #1989fa;
  }

  .section-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
  }
}

/* 品牌故事 */
.brand-story-section {
  background: white;
  margin: 0 16px 16px;
  border-radius: 16px;
  padding: 20px;

  .brand-story-content {
    p {
      margin: 0;
      font-size: 14px;
      line-height: 1.8;
      color: #333;
      text-align: justify;
    }
  }
}

/* 设计师团队 */
.designers-section {
  background: white;
  margin: 0 16px 16px;
  border-radius: 16px;
  padding: 20px;

  .designers-swipe {
    margin: 0 -10px;

    .designer-item {
      padding: 0 10px;
    }

    .designer-card {
      text-align: center;
      padding: 12px;
      border-radius: 12px;
      background: #f8f9fa;
      transition: background-color 0.3s;

      &:hover {
        background: #f0f0f0;
      }

      .designer-avatar {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        object-fit: cover;
        margin: 0 auto 8px;
        border: 2px solid white;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      .designer-info {
        .designer-name {
          margin: 0 0 4px;
          font-size: 14px;
          font-weight: 600;
          color: #1a1a1a;
        }

        .designer-role {
          margin: 0;
          font-size: 12px;
          color: #666;
        }
      }
    }
  }
}

/* 产品列表 */
.products-section {
  background: white;
  margin: 0 16px 16px;
  border-radius: 16px;
  padding: 20px;

  .section-header {
    justify-content: space-between;

    .product-count {
      font-size: 14px;
      color: #999;
    }
  }

  .products-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-bottom: 20px;
  }

  .product-card {
    border-radius: 12px;
    overflow: hidden;
    background: #f8f9fa;
    cursor: pointer;
    transition: transform 0.3s, box-shadow 0.3s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .product-image {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 100%;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .product-badge {
        position: absolute;
        top: 8px;
        right: 8px;
      }
    }

    .product-info {
      padding: 12px;

      .product-name {
        margin: 0 0 4px;
        font-size: 14px;
        font-weight: 600;
        color: #1a1a1a;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .product-desc {
        margin: 0 0 8px;
        font-size: 12px;
        color: #666;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        line-height: 1.4;
      }

      .product-price {
        font-size: 16px;
        font-weight: 700;
        color: #ff4444;
      }
    }
  }

  .load-more {
    text-align: center;

    .load-more-btn {
      width: 200px;
    }
  }
}

/* 品牌认证信息 */
.verification-section {
  background: white;
  margin: 0 16px 16px;
  border-radius: 16px;
  padding: 20px;

  .verification-content {
    .verification-stats {
      display: flex;
      gap: 20px;
      margin-bottom: 20px;

      .verification-item {
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;

        .verification-icon {
          font-size: 24px;
          color: #1989fa;
        }

        .verification-info {
          .verification-number {
            font-size: 20px;
            font-weight: 700;
            color: #1a1a1a;
            margin-bottom: 2px;
          }

          .verification-label {
            font-size: 12px;
            color: #999;
          }
        }
      }
    }

    .verify-btn {
      width: 100%;
      height: 44px;
      border-radius: 22px;
      font-size: 16px;
      font-weight: 500;
    }
  }
}

/* 底部操作栏 */
.bottom-actions {
  position: sticky;
  bottom: 0;
  background: white;
  padding: 12px 16px;
  display: flex;
  gap: 12px;
  border-top: 1px solid #f0f0f0;
  margin-top: 16px;

  .action-btn {
    flex: 1;
    height: 44px;
    border-radius: 22px;
    font-size: 14px;
    font-weight: 500;

    &.primary-btn {
      background: linear-gradient(135deg, #1989fa 0%, #007aff 100%);
      border: none;
    }

    &.secondary-btn {
      border-color: #dcdfe6;
      color: #606266;

      &.followed {
        background: #ffeaea;
        border-color: #ff4444;
        color: #ff4444;
      }
    }
  }
}

/* 1080×1920 设备适配 (竖屏大屏设备) */
@media (min-width: 1080px) and (min-height: 1920px) {
  .brand-header {
    margin: 0 24px 24px;
    padding: 32px;
  }

  .brand-basic-info {
    gap: 32px;
    margin-bottom: 24px;

    .logo-section .brand-logo {
      width: 150px;
      height: 150px;
      border-radius: 24px;
    }

    .brand-info {
      .brand-name {
        font-size: 32px;
        margin-bottom: 12px;
      }

      .brand-desc {
        font-size: 18px;
        margin-bottom: 24px;
      }
    }

    .brand-stats {
      gap: 32px;

      .stat-item {
        .stat-number {
          font-size: 28px;
        }

        .stat-label {
          font-size: 14px;
        }
      }
    }
  }

  .brand-time-info {
    gap: 32px;
    padding-top: 24px;

    .time-item {
      gap: 16px;

      .time-icon {
        font-size: 24px;
      }

      .time-content {
        .time-label {
          font-size: 14px;
        }

        .time-value {
          font-size: 16px;
        }
      }
    }
  }

  .brand-story-section,
  .designers-section,
  .products-section,
  .verification-section {
    margin: 0 24px 24px;
    padding: 32px;
  }

  .section-header {
    margin-bottom: 24px;

    .section-icon {
      font-size: 24px;
    }

    .section-title {
      font-size: 24px;
    }
  }

  .brand-story-content p {
    font-size: 18px;
    line-height: 2;
  }

  .designers-swipe .designer-card {
    padding: 16px;

    .designer-avatar {
      width: 80px;
      height: 80px;
      margin-bottom: 12px;
    }

    .designer-name {
      font-size: 16px;
    }

    .designer-role {
      font-size: 14px;
    }
  }

  .products-section {
    .products-grid {
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
      margin-bottom: 32px;
    }

    .product-card .product-info {
      padding: 16px;

      .product-name {
        font-size: 16px;
      }

      .product-desc {
        font-size: 14px;
      }

      .product-price {
        font-size: 18px;
      }
    }
  }

  .verification-content {
    .verification-stats {
      gap: 32px;
      margin-bottom: 32px;

      .verification-item {
        gap: 16px;

        .verification-icon {
          font-size: 32px;
        }

        .verification-info {
          .verification-number {
            font-size: 28px;
          }

          .verification-label {
            font-size: 14px;
          }
        }
      }
    }

    .verify-btn {
      height: 56px;
      border-radius: 28px;
      font-size: 18px;
    }
  }

  .bottom-actions {
    padding: 16px 24px;
    gap: 16px;

    .action-btn {
      height: 56px;
      border-radius: 28px;
      font-size: 16px;
    }
  }
}

/* 平板设备 (768px - 1199px) */
@media (max-width: 1199px) and (min-width: 768px) {
  .brand-header,
  .brand-story-section,
  .designers-section,
  .products-section,
  .verification-section {
    margin: 0 20px 20px;
    padding: 24px;
  }

  .products-section .products-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* 移动端适配 (767px 及以下) */
@media (max-width: 767px) {
  .brand-header {
    margin: 0 12px 12px;
    padding: 16px;
  }

  .brand-basic-info {
    flex-direction: column;
    gap: 16px;
    text-align: center;

    .logo-section {
      display: flex;
      justify-content: center;
    }

    .brand-stats {
      justify-content: center;
    }
  }

  .brand-time-info {
    flex-direction: column;
    gap: 16px;
  }

  .brand-story-section,
  .designers-section,
  .products-section,
  .verification-section {
    margin: 0 12px 12px;
    padding: 16px;
  }

  .products-section .products-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .verification-content .verification-stats {
    flex-direction: column;
    gap: 16px;
  }

  .bottom-actions {
    padding: 8px 12px;

    .action-btn {
      font-size: 13px;
    }
  }
}

/* 超小屏幕设备 (480px 及以下) */
@media (max-width: 480px) {
  .brand-header,
  .brand-story-section,
  .designers-section,
  .products-section,
  .verification-section {
    margin: 0 8px 8px;
    padding: 12px;
  }

  .bottom-actions {
    flex-direction: column;
    gap: 8px;

    .action-btn {
      width: 100%;
    }
  }
}

/* 横屏模式适配 */
@media (max-height: 500px) and (orientation: landscape) {
  .brand-basic-info {
    flex-direction: row;
    text-align: left;
  }

  .brand-time-info {
    flex-direction: row;
  }

  .products-section .products-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* 暗色模式支持 */
@media (prefers-color-scheme: dark) {
  .brand-detail-page {
    background-color: #1a1a1a;
  }

  .brand-header,
  .brand-story-section,
  .designers-section,
  .products-section,
  .verification-section,
  .bottom-actions {
    background: #2a2a2a;
  }

  .brand-name,
  .section-title,
  .designer-name,
  .product-name,
  .verification-number {
    color: #ffffff;
  }

  .brand-desc,
  .brand-story-content p,
  .designer-role,
  .product-desc,
  .verification-label {
    color: #cccccc;
  }

  .brand-stats .stat-label,
  .time-label,
  .product-count {
    color: #999999;
  }

  .product-card {
    background: #333333;
  }

  .designer-card {
    background: #333333;

    &:hover {
      background: #3a3a3a;
    }
  }
}
</style>
